import { Helmet } from "react-helmet-async";
import { useGlobalSeo } from "./seo";

export function GlobalSeo() {
  const seo = useGlobalSeo();

  if (!seo) return null;

  //console.log(seo.data)

  return (
    <Helmet>
      <meta name="description" content={seo.data.description} />
      <meta name="keywords" content={seo.data.keywords} />
    </Helmet>
  );
}
